export default "__VITE_ASSET__xqJQ15Hg__"